import * as React from 'react';
import { useLocation } from 'react-router-dom';

import Pagination from 'antd/lib/pagination';

import { ItemsProvider, useItemsProviderContext, SortingDirection } from '@common/react/components/Core/ItemsProvider/ItemsProvider';
import ServerPageProvider from '@common/react/components/Core/ServerPageProvider/ServerPageProvider';
import { getSearchParamsFromUrl } from '@common/react/utils/FIltersParamsFromUrl/FiltersParamsFromUrl';

import { Specialty } from '@commonTuna/react/objects/Specialty';
import { LogoLoaderPage } from '@commonTuna/react/components/UI/LogoLoader/LogoLoader';

import '@app/scss/pages/catalog.scss';
import SpecialtyTag from '@app/components/Pages/Specialties/SpecialtyTag';

const SpecialtyList: React.FC = () => {
	const context = useItemsProviderContext<Specialty>();

	if (!context.actions) throw 'Need ItemsProvider context!';

	const { state: { items, pagination }, actions: { handleChange } } = context;

	const onPaginationChange = (current, pageSize) => {
		handleChange({ page: current, pageSize });
	};

	return (<div className="catalog mb10">
		<ul className="catalog__list">
			{items.map((item) => <li key={item.id} className="catalog__list__item">
				<SpecialtyTag specialty={item} />
			</li>)}
		</ul>
		{pagination?.total > items.length && <div className="pull-right mt10 mb10">
			<Pagination onChange={onPaginationChange} {...pagination} />
		</div>}
	</div>);
};

const Specialties: React.FC = () => {
	const location = useLocation();

	const params = getSearchParamsFromUrl(location);

	return <>
		<ServerPageProvider
			path="specialties"
			defaultTitle="Specialties"
			loader={<LogoLoaderPage />}
			inner={(page) => (
				<ItemsProvider<Specialty>
					type="specialty"
					items={page?.items?.list}
					loadRequest="specialtyPortalPageViewListRemote"
					filters={{ column: [{ caption: 'name', direction: SortingDirection.Ascending }] }}
					pagination={{
						pageSize: params.count || 200, current: 1, total: page?.items?.count,
					}}
					withHandleUrl
				>
					<div className="container">
						<div className="site-headline site-headline_with-button clearfix">
							<h1 className="pull-left">Specialties</h1>
						</div>
						<SpecialtyList />
					</div>
				</ItemsProvider>
			)}
		/>
	</>;
};

export default Specialties;
